const initialState = {
    activeTab: 0,
    newestPeriodFirst: false
};

const earnedRecognitionReducer = (state = initialState, action) => {
    switch (action.type) {
        case "SET_EARNED_RECOGNITION_TAB":
            return {
                ...state,
                activeTab: action.payload
            };
        case "SET_EARNED_RECOGNITION_PERIOD_ORDER":
            return {
                ...state,
                newestPeriodFirst: action.payload
            };
        case "RESET_STORE":
            return initialState;
        default:
            return state;
    }
};

export default earnedRecognitionReducer;
